import { set } from 'vue'

export const state = () => ({
  currAgreement: null
})

export const mutations = {
  setCurrAgreement(state, payload) {
    state.currAgreement = payload
  },
  setVehicle(state, payload) {
    state.currAgreement.vehicle = payload
  },
  setNewSeller(state, seller) {
    state.currAgreement.sellers.push(seller)
  },
  setNewBuyer(state, buyer) {
    state.currAgreement.buyers.push(buyer)
  },
  updateSeller(state, { id, payload }) {
    const index = state.currAgreement.sellers.findIndex((i) => i.id === id)
    set(state.currAgreement.sellers, index, payload)
  },
  updateBuyer(state, { id, payload }) {
    const index = state.currAgreement.buyers.findIndex((i) => i.id === id)
    set(state.currAgreement.buyers, index, payload)
  },
  deleteSeller(state, id) {
    state.currAgreement.sellers = state.currAgreement.sellers.filter(
      (x) => x.id !== id
    )
  },
  deleteBuyer(state, id) {
    state.currAgreement.buyers = state.currAgreement.buyers.filter(
      (x) => x.id !== id
    )

    if (state.currAgreement?.payer?.id === id) {
      state.currAgreement.payer = null
    }
  },
  deleteSellerEmail(state, { entityId, emailId }) {
    const index = state.currAgreement.sellers.findIndex(
      (i) => i.id === entityId
    )
    set(
      state.currAgreement.sellers[index],
      'emails',
      state.currAgreement.sellers[index].emails.filter((x) => x.id !== emailId)
    )
  },
  deleteSellerPhone(state, { entityId, phoneId }) {
    const index = state.currAgreement.sellers.findIndex(
      (i) => i.id === entityId
    )
    set(
      state.currAgreement.sellers[index],
      'phones',
      state.currAgreement.sellers[index].phones.filter((x) => x.id !== phoneId)
    )
  },
  deleteBuyerEmail(state, { entityId, emailId }) {
    const index = state.currAgreement.buyers.findIndex((i) => i.id === entityId)
    set(
      state.currAgreement.buyers[index],
      'emails',
      state.currAgreement.buyers[index].emails.filter((x) => x.id !== emailId)
    )
  },
  deleteBuyerPhone(state, { entityId, phoneId }) {
    const index = state.currAgreement.buyers.findIndex((i) => i.id === entityId)
    set(
      state.currAgreement.buyers[index],
      'phones',
      state.currAgreement.buyers[index].phones.filter((x) => x.id !== phoneId)
    )
  },
  setPrice(state, price) {
    state.currAgreement.price = price
  },
  setCurrency(state, currency) {
    state.currAgreement.currency = currency
  },
  setFinancing(state, { type, payload }) {
    set(state.currAgreement.financing, type, payload)
  },
  setAgentFee(state, payload) {
    state.currAgreement.agentFee = payload
  },
  setRegistrationFee(state, payload) {
    state.currAgreement.registrationFee = payload
  },
  setInsurance(state, { type, payload }) {
    set(state.currAgreement, type, payload)
  },
  setHandlingOver(state, date) {
    state.currAgreement.handlingOver = date
  },
  setPayer(state, payload) {
    state.currAgreement.buyerInfo.payer = payload
  },
  setPayoutMethod(state, payload) {
    state.currAgreement.sellerInfo.payoutMethod = payload
  },
  setCommitted(state, payload) {
    state.currAgreement.committed = payload
  },
  setNewLoan(state, loan) {
    state.currAgreement.loans.push(loan)
  },
  updateLoan(state, { id, payload }) {
    const index = state.currAgreement.loans?.findIndex((i) => i.id === id)
    set(state.currAgreement.loans, index, payload)
  },
  setBuyerInfo(state, payload) {
    state.currAgreement.buyerInfo = payload
  },
  setSellerInfo(state, payload) {
    state.currAgreement.sellerInfo = payload
  },
  setPdf(state, src) {
    state.currAgreement.pdf = src
  }
}

// TODO: Implement calls to real endpoints
export const actions = {
  // TODO: Delete after testing
  fillAgreementInfo({ commit }) {
    const buyer = {
      id: Math.random(),
      name: 'Buyer Name',
      is_individual: true,
      identifier: 1111111112,
      identifier_country: 'IS',
      phones: [
        {
          id: Math.random(),
          phone: {
            country_code: '+354',
            country_code_id: 1,
            area_code: null,
            number: 1111111,
            country_code_obj: {
              id: 1,
              country: 'Iceland',
              code: '+354',
              iso: 'IS'
            }
          }
        }
      ],
      emails: [
        {
          id: Math.random(),
          email: {
            email: 'buyer@email.com'
          }
        }
      ],
      signature: null,
      created_at: '2023-09-05T11:40:38.591623Z',
      agents: [],
      parent: null,
      title: 'BR',
      role: 'BR',
      external_contract_entity_id: null
    }
    commit('setCurrAgreement', {
      id: 1,
      vehicle: {
        type: 'Suzuki Grand Vitara',
        registrationNumber: 'LHY80',
        specification: '2.0 Diesel',
        yearOfProduction: 2016,
        factoryN: 'WVWZZZ7RUDY244789',
        firstListed: '03.06.2016',
        loans: 200000,
        owners: [
          {
            name: 'Ian Gunnur Kristianson',
            buyingDate: '16.09.2017',
            sellingDate: '08.12.2018',
            price: 1200000
          },
          {
            name: 'John Doe',
            buyingDate: '14.03.2012',
            sellingDate: '16.09.2017',
            price: 1000000
          }
        ],
        accidents: [
          {
            owner: 'Ian Gunnur Kristianson',
            accidentDate: '08.10.2018',
            details: 'Short description of accident'
          },
          {
            owner: 'John Doe',
            accidentDate: '14.03.2013',
            details:
              'Not a short description of accident with some special details'
          }
        ]
      },
      sellers: [
        {
          id: Math.random(),
          name: 'Seller Name',
          is_individual: true,
          identifier: 1111111111,
          identifier_country: 'IS',
          phones: [
            {
              id: Math.random(),
              phone: {
                country_code: '+354',
                country_code_id: 1,
                area_code: null,
                number: 1111112,
                country_code_obj: {
                  id: 1,
                  country: 'Iceland',
                  code: '+354',
                  iso: 'IS'
                }
              }
            }
          ],
          emails: [
            {
              id: Math.random(),
              email: {
                email: 'seller@email.com'
              }
            }
          ],
          signature: null,
          created_at: '2023-09-05T11:40:38.591623Z',
          agents: [],
          parent: null,
          title: 'SL',
          role: 'SL',
          external_contract_entity_id: null
        }
      ],
      buyers: [{ ...buyer }],
      price: 1000000,
      currency: {
        id: 1,
        quote: 'ISK',
        symbol: 'kr',
        title: 'Íslensk króna'
      },
      financing: {
        equity: { value: 300000 },
        loan: { value: 200000 },
        anotherVehicle: {
          value: 500000,
          vehicle: {
            type: 'Volkswagen Polo',
            registrationNumber: 'LHY80',
            specification: '1.2 Diesel',
            yearOfProduction: 2018,
            factoryN: 'SUWSZZ7RUDY820473',
            firstListed: '03.06.2012',
            loans: null,
            owners: [
              {
                name: 'John Doe',
                buyingDate: '14.03.2012',
                sellingDate: '16.09.2017',
                price: 1000000
              }
            ],
            accidents: []
          }
        }
      },
      agentFee: {
        type: 'SL',
        amount: 20000
      },
      registrationFee: 'BR',
      vehicleInsurance: {
        company: 'VIS',
        collisionInsurance: true
      },
      anotherVehicleInsurance: {
        company: 'VIS'
      },
      buyerInfo: {
        amount: 340500,
        payer: { ...buyer },
        payment: {
          date: '2023-07-14',
          amount: 340500
        }
      },
      sellerInfo: {
        amount: 259500,
        paidOut: true,
        payoutMethod: {
          id: Math.random(),
          bank_account: {
            iban: 'BY34BAPB68544020562162332853',
            icelandic_format: {
              kt: '5621623328',
              bank: 'BAPB',
              hb: '68',
              rkn: '544020'
            },
            bank: null
          }
        }
      },
      loans: [
        {
          id: Math.random(),
          number: '#8978AAN7',
          balance: 200000,
          currency: {
            id: 1,
            quote: 'ISK',
            symbol: 'kr',
            title: 'Íslensk króna'
          },
          settled: false,
          settlementAccount: {
            personal_id: '1231231235',
            personal_id_country: 'IS',
            accountNumber: 'Test'
          },
          creditor: {
            id: '1231231234',
            country: 'IS',
            name: 'Arion Banki'
          }
        },
        {
          id: Math.random(),
          number: '#7978AAN7',
          balance: 2000,
          currency: {
            id: 1,
            quote: 'ISK',
            symbol: 'kr',
            title: 'Íslensk króna'
          },
          settled: true,
          settlementAccount: {
            personal_id: '1231231236',
            personal_id_country: 'IS',
            accountNumber: 'Test 2'
          },
          creditor: {
            id: '1231231234',
            country: 'IS',
            name: 'Arion Banki'
          }
        }
      ],
      handlingOver: '2023-10-01',
      fees: {
        service: 15000,
        registration: 2500,
        notary: 3000
      },
      pdf: null,
      committed: null,
      signed: null
    })
  },
  async fetchAgreementDetails({ commit }, id) {
    // const { data } = await this.$axios.get(`car-agreement/${id}/`)
    // commit('setCurrAgreement', data)
    await commit('setCurrAgreement', {
      id,
      vehicle: null,
      sellers: [],
      buyers: [],
      price: null,
      currency: null,
      financing: {
        equity: null,
        loan: null,
        anotherVehicle: null
      },
      agentFee: null,
      registrationFee: null,
      vehicleInsurance: null,
      anotherVehicleInsurance: null,
      buyerInfo: {
        amount: 0,
        payer: null,
        payment: null
      },
      sellerInfo: {
        amount: 0,
        paidOut: false,
        payoutMethod: null
      },
      loans: [],
      handlingOver: null,
      fees: {
        service: 15000,
        registration: 2500,
        notary: 3000
      },
      pdf: null,
      committed: null,
      signed: null
    })
  },
  async fetchVehicleInformation(context, regNumber) {
    // const { data } = await this.$axios.get(`utilities/vehicle/${regNumber}/`)
    // return data
    if (regNumber === '1') {
      return {
        type: 'Suzuki Grand Vitara',
        registrationNumber: 'LHY80',
        specification: '2.0 Diesel',
        yearOfProduction: 2016,
        factoryN: 'WVWZZZ7RUDY244789',
        firstListed: '03.06.2016',
        loans: 200000,
        owners: [
          {
            name: 'Ian Gunnur Kristianson',
            buyingDate: '16.09.2017',
            sellingDate: '08.12.2018',
            price: 1200000
          },
          {
            name: 'John Doe',
            buyingDate: '14.03.2012',
            sellingDate: '16.09.2017',
            price: 1000000
          }
        ],
        accidents: [
          {
            owner: 'Ian Gunnur Kristianson',
            accidentDate: '08.10.2018',
            details: 'Short description of accident'
          },
          {
            owner: 'John Doe',
            accidentDate: '14.03.2013',
            details:
              'Not a short description of accident with some special details'
          }
        ]
      }
    } else if (regNumber === '2') {
      return await {
        type: 'Volkswagen Polo',
        registrationNumber: 'LHY80',
        specification: '1.2 Diesel',
        yearOfProduction: 2018,
        factoryN: 'SUWSZZ7RUDY820473',
        firstListed: '03.06.2012',
        loans: null,
        owners: [
          {
            name: 'John Doe',
            buyingDate: '14.03.2012',
            sellingDate: '16.09.2017',
            price: 1000000
          }
        ],
        accidents: []
      }
    }
    throw new Error('Not found')
  },
  async createSeller({ commit }, { id, payload }) {
    // const { data } = await this.$axios.post(
    //   `car-agreement/${id}/sellers/`,
    //   payload
    // )
    // commit('setNewSeller', data)
    const data = {
      id: Math.random(),
      name: payload.name,
      is_individual: null,
      identifier: 1111111111,
      identifier_country: 'IS',
      phones: [
        {
          id: Math.random(),
          phone: {
            country_code: '+354',
            country_code_id: payload.phone_objs[0].country_code_id,
            area_code: null,
            number: payload.phone_objs[0].number,
            country_code_obj: {
              id: 1,
              country: 'Iceland',
              code: '+354',
              iso: 'IS'
            }
          }
        }
      ],
      emails: [
        {
          id: Math.random(),
          email: {
            email: payload.email_objs[0].email
          }
        }
      ],
      signature: null,
      created_at: '2023-09-05T11:40:38.591623Z',
      agents: [],
      parent: null,
      title: 'SL',
      role: 'SL',
      external_contract_entity_id: null
    }
    await commit('setNewSeller', data)
  },
  async createBuyer({ commit }, { id, payload }) {
    // const { data } = await this.$axios.post(
    //   `car-agreement/${id}/sellers/`,
    //   payload
    // )
    // commit('setNewBuyer', data)
    const data = await {
      id: Math.random(),
      name: payload.name,
      is_individual: null,
      identifier: 1111111112,
      identifier_country: 'IS',
      phones: [
        {
          id: Math.random(),
          phone: {
            country_code: '+354',
            country_code_id: payload.phone_objs[0].country_code_id,
            area_code: null,
            number: payload.phone_objs[0].number,
            country_code_obj: {
              id: 1,
              country: 'Iceland',
              code: '+354',
              iso: 'IS'
            }
          }
        }
      ],
      emails: [
        {
          id: Math.random(),
          email: {
            email: payload.email_objs[0].email
          }
        }
      ],
      signature: null,
      created_at: '2023-09-05T11:40:38.591623Z',
      agents: [],
      parent: null,
      title: 'BR',
      role: 'BR',
      external_contract_entity_id: null
    }
    commit('setNewBuyer', data)
  },
  async deleteSeller({ commit }, id) {
    // const { data } = await this.$axios.delete(`car-agreement/seller/${id}/`)
    await commit('deleteSeller', id)
  },
  async deleteBuyer({ commit }, id) {
    // const { data } = await this.$axios.delete(`car-agreement/buyer/${id}/`)
    await commit('deleteBuyer', id)
  },
  async deleteEntityEmail({ commit }, { entityId, emailId, entityType }) {
    // const { data } = await this.$axios.delete(`car-agreement/entity-emails/${emailId}/`)
    switch (entityType) {
      case 'SL':
        await commit('deleteSellerEmail', { entityId, emailId })
        break
      case 'BR':
        commit('deleteBuyerEmail', { entityId, emailId })
        break
      default:
        break
    }
    // return data
  },
  async deleteEntityPhone({ commit }, { entityId, phoneId, entityType }) {
    // const { data } = await this.$axios.delete(`car-agreement/entity-phones/${emailId}/`)
    switch (entityType) {
      case 'SL':
        await commit('deleteSellerPhone', { entityId, phoneId })
        break
      case 'BR':
        commit('deleteBuyerPhone', { entityId, phoneId })
        break
      default:
        break
    }
    // return data
  },
  async updateEntity({ commit }, { id, payload, entityType }) {
    // const { data } = await this.$axios.patch(`car-agreement/entities/${id}/`, payload)
    const data = await {
      id,
      name: 'Updated Name',
      is_individual: true,
      identifier: '111111111',
      identifier_country: 'IS',
      phones: [
        {
          id: Math.random(),
          phone: {
            country_code: '+354',
            country_code_id: 1,
            area_code: null,
            number: '1234567890',
            country_code_obj: {
              id: 1,
              country: 'Iceland',
              code: '+354',
              iso: 'IS'
            }
          }
        }
      ],
      emails: [
        {
          id: Math.random(),
          email: {
            email: 'updated@email.com'
          }
        }
      ],
      signature: null,
      created_at: '2023-09-05T11:40:38.591623Z',
      agents: [],
      parent: null,
      title: entityType,
      role: entityType,
      external_contract_entity_id: null
    }
    switch (entityType) {
      case 'SL':
        commit('updateSeller', { id, payload: data })
        break
      case 'BR':
        commit('updateBuyer', { id, payload: data })
        break
      default:
        break
    }
    // return data
  },
  async updateAgreement({ dispatch }, { id, payload }) {
    // await this.$axios.patch(`car-agreement/${id}/`, payload)
    await dispatch('updatePaymentInfo')
  },
  async deleteAgentFee({ commit, dispatch }) {
    // await this.$axios.delete(`car-agreement/${id}/agent-fee`)
    await commit('setAgentFee', null)
    dispatch('updatePaymentInfo')
  },
  async deleteAnotherVehicleInsurance({ commit }) {
    // Should we delete information from frontend or this functionality will be on frontend side?
    // await this.$axios.delete(`car-agreement/${id}/another-vehicle-insurance`)
    await commit('setInsurance', {
      type: 'anotherVehicleInsurance',
      payload: null
    })
  },
  async updatePayer(context, { id, payload }) {
    // await this.$axios.patch(`car-agreement/${id}/payer`, payload)
  },
  async updatePayoutMethod({ commit }, { id, payload }) {
    // await this.$axios.patch(`car-agreement/${id}/payout-method`, payload)
    await commit('setPayoutMethod', payload)
  },
  async updatePaymentInfo({ state, commit }) {
    // const data = await this.$axios.get(`car-agreement/${state.currAgreement.id}/payment-info`)
    // commit('setBuyerInfo', data.buyer)
    // commit('setSellerInfo', data.seller)
    await console.log('Payment info updated')
  },
  async createLoan({ commit }, { id, payload }) {
    // const { data } = await this.$axios.post(
    //   `car-agreement/${id}/loans/`,
    //   payload
    // )
    // commit('setNewLoan', data)
    const data = await {
      id: Math.random(),
      number: payload.number,
      balance: payload.balance,
      currency: payload.currency,
      settled: false,
      creditor: {
        id: payload.identifier,
        country: payload.identifier_country,
        name: payload.name
      }
    }
    commit('setNewLoan', data)
  },
  async fetchPdfBase64({ commit }, id) {
    // const { file } = await this.$axios.patch(`car-agreement/${id}/base64/`, payload)
    // const parsed = JSON.parse(file)
    const parsed =
      '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'
    await commit('setPdf', `data:application/pdf;base64,${parsed}`)
  },
  async commitAgreement({ commit }, id) {
    // await this.$axios.patch(`car-agreement/${id}/commit`, payload)
    await commit('setCommitted', true)
  },
  async uncommitAgreement({ commit }, id) {
    // await this.$axios.patch(`car-agreement/${id}/uncommit`, payload)
    await commit('setCommitted', false)
  }
}

export const getters = {
  vehicleCompleted: (state) => {
    return !!state.currAgreement?.vehicle?.registrationNumber
  },
  sellersAndBuyersCompleted: (state) => {
    const isValidParty = (e) =>
      (e.is_individual || e.agents?.length > 0) &&
      e.phones?.length > 0 &&
      e.emails?.length > 0 &&
      e.agents.every(
        (a) => a.phones?.length > 0 && a.emails?.length > 0 && a.is_individual
      )
    return (
      state.currAgreement &&
      state.currAgreement.sellers?.length > 0 &&
      state.currAgreement.buyers?.length > 0 &&
      state.currAgreement.sellers?.every((e) => isValidParty(e)) &&
      state.currAgreement.buyers?.every((e) => isValidParty(e))
    )
  },
  purchasingPriceCompleted: (state) => {
    return !!state.currAgreement?.price
  },
  financingCompleted: (state) => {
    const fund =
      state.currAgreement?.price -
      (state.currAgreement?.financing?.equity?.value ?? 0) -
      (state.currAgreement?.financing?.loan?.value ?? 0) -
      (state.currAgreement?.financing?.anotherVehicle?.value ?? 0)

    if (state.currAgreement?.financing?.anotherVehicle?.value > 0) {
      // TODO: Implement owner match logic
      const ownerMatch = true
      return (
        !!state.currAgreement?.price &&
        fund === 0 &&
        !!state.currAgreement?.financing?.anotherVehicle?.vehicle &&
        !state.currAgreement?.financing?.anotherVehicle?.vehicle?.loans &&
        ownerMatch
      )
    }

    return !!state.currAgreement?.price && fund === 0
  },
  feesCompleted: (state) => {
    if (state.currAgreement?.agentFee) {
      return (
        !!state.currAgreement?.registrationFee &&
        !!state.currAgreement?.agentFee?.type &&
        !!state.currAgreement?.agentFee?.amount > 0
      )
    }
    return !!state.currAgreement?.registrationFee
  },
  insuranceCompanyCompleted: (state) => {
    if (state.currAgreement?.financing?.anotherVehicle?.value > 0) {
      return (
        !!state.currAgreement?.vehicleInsurance &&
        !!state.currAgreement?.anotherVehicleInsurance
      )
    }
    return !!state.currAgreement?.vehicleInsurance
  },
  sellersBankCompleted: (state) => {
    return !!state.currAgreement?.sellerInfo?.payoutMethod?.id
  },
  handoverDateCompleted: (state) => {
    return !!state.currAgreement?.handlingOver
  },
  contractCommitted: (state) => {
    return state.currAgreement?.committed
  },
  contractSigned: (state) => {
    return state.currAgreement?.signed
  },
  paymentSettled: (state) => {
    return (
      state.currAgreement?.sellerInfo?.paidOut &&
      state.currAgreement?.buyerInfo?.payment
    )
  },
  agreementStepValid: (state, getters) => {
    return getters.vehicleCompleted && getters.sellersAndBuyersCompleted
  },
  financingStepValid: (state, getters) => {
    return (
      getters.purchasingPriceCompleted &&
      getters.financingCompleted &&
      getters.feesCompleted &&
      getters.insuranceCompanyCompleted
    )
  },
  summaryStepValid: (state, getters) => {
    return getters.sellersBankCompleted && getters.handoverDateCompleted
  }
}
